import React from 'react'
import InputKeyValue from '../shared/InputKeyValue'
import KeyDropdownValue from '../shared/KeyDropdownValue'
import { prefix } from '../normalizer'

const tRegister = prefix('gamification2026.register')

const AddressForm = ({ required, countries, states, selectedCountry, selectedState, onChangeAddress, onChangeCountry, onChangeState }) => {
  return (
    <div className="register__section">
      <h3 className="register__section-title">{tRegister('address-title')}</h3>
      <InputKeyValue
        title={tRegister('address')}
        placeholder={tRegister('address-placeholder')}
        name="address1"
        type="text"
        required={required}
        onChange={onChangeAddress}
      />
      <InputKeyValue
        title={tRegister('address2')}
        placeholder={tRegister('address2-placeholder')}
        name="address2"
        type="text"
        onChange={onChangeAddress}
      />
      <div className="register__row">
        <InputKeyValue
          title={tRegister('zipcode')}
          placeholder={tRegister('zipcode-placeholder')}
          name="zip_code"
          type="text"
          required={required}
          onChange={onChangeAddress}
        />
        <InputKeyValue
          title={tRegister('city')}
          placeholder={tRegister('city-placeholder')}
          name="city"
          type="text"
          required={required}
          onChange={onChangeAddress}
        />
      </div>
      <div className="register__row">
        <KeyDropdownValue
          title={tRegister('country')}
          placeholder={tRegister('country-placeholder')}
          name="pais"
          options={countries}
          optionsLabel="name"
          optionsId="id"
          selectedValue={selectedCountry}
          onChange={onChangeCountry}
        />
        <KeyDropdownValue
          title={tRegister('state')}
          placeholder={tRegister('state-placeholder')}
          name="state"
          options={states}
          optionsLabel="name"
          optionsId="id"
          selectedValue={selectedState}
          onChange={onChangeState}
        />
      </div>
    </div>
  )
}

export default AddressForm
